import { render, staticRenderFns } from "./goodsManage.vue?vue&type=template&id=6201a98b&scoped=true&"
import script from "./goodsManage.vue?vue&type=script&lang=js&"
export * from "./goodsManage.vue?vue&type=script&lang=js&"
import style0 from "./goodsManage.vue?vue&type=style&index=0&id=6201a98b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6201a98b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6201a98b')) {
      api.createRecord('6201a98b', component.options)
    } else {
      api.reload('6201a98b', component.options)
    }
    module.hot.accept("./goodsManage.vue?vue&type=template&id=6201a98b&scoped=true&", function () {
      api.rerender('6201a98b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/onlineshop/goodsManage.vue"
export default component.exports